/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file api.ts
 * @desc Created on Tue Mar 07 2023 12:45:54
 * @copyright All rights reserved @ Inarix
 */

import {
  ActionReducerMapBuilder,
  AsyncThunk,
  Draft,
  PayloadAction,
} from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";

export function errorWrap(err: unknown): never {
  if ((err as any).response?.data?.message) {
    throw new Error((err as any).response?.data.message);
    // } else if ((err as AxiosError).request) {
    //   throw new Error('No response received');
  } else {
    throw err;
  }
}

export async function queryWrap(
  resp: Promise<AxiosResponse>,
): Promise<AxiosResponse> {
  try {
    return await resp;
  } catch (err) {
    errorWrap(err);
  }
}

export async function tryCatch<T, E extends Error = Error>(
  promise: Promise<T>,
) {
  try {
    const result = await promise;
    return { result, error: null };
  } catch (err) {
    return { result: null, error: err as E };
  }
}

export function baseCases<T extends { loading: boolean; error: string }, R>(
  thunk: AsyncThunk<R, any, any>,
  builder: ActionReducerMapBuilder<T>,
  fulfilled: (state: Draft<T>, action: PayloadAction<R>) => void,
) {
  return builder
    .addCase(thunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
    .addCase(thunk.fulfilled, fulfilled);
}
